/**
 * @generated SignedSource<<d1c9d8ddd59f365fff0a1edfeb997431>>
 * @relayHash ae0c628cf339b6324362da464e2e3b13
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ae0c628cf339b6324362da464e2e3b13

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type UpdateIssueCommentInput = {
  body: string;
  bodyVersion?: string | null | undefined;
  clientMutationId?: string | null | undefined;
  id: string;
};
export type updateIssueCommentBodyMutation$variables = {
  input: UpdateIssueCommentInput;
};
export type updateIssueCommentBodyMutation$data = {
  readonly updateIssueComment: {
    readonly issueComment: {
      readonly body: string;
      readonly bodyHTML: string;
      readonly bodyVersion: string;
      readonly id: string;
      readonly viewerCanUpdate: boolean;
      readonly " $fragmentSpreads": FragmentRefs<"IssueCommentViewerMarkdownViewer">;
    } | null | undefined;
  } | null | undefined;
};
export type updateIssueCommentBodyMutation$rawResponse = {
  readonly updateIssueComment: {
    readonly issueComment: {
      readonly body: string;
      readonly bodyHTML: string;
      readonly bodyVersion: string;
      readonly id: string;
      readonly viewerCanUpdate: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type updateIssueCommentBodyMutation = {
  rawResponse: updateIssueCommentBodyMutation$rawResponse;
  response: updateIssueCommentBodyMutation$data;
  variables: updateIssueCommentBodyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "unfurlReferences",
      "value": true
    }
  ],
  "kind": "ScalarField",
  "name": "bodyHTML",
  "storageKey": "bodyHTML(unfurlReferences:true)"
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bodyVersion",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanUpdate",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateIssueCommentBodyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateIssueCommentPayload",
        "kind": "LinkedField",
        "name": "updateIssueComment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "IssueComment",
            "kind": "LinkedField",
            "name": "issueComment",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "IssueCommentViewerMarkdownViewer"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateIssueCommentBodyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateIssueCommentPayload",
        "kind": "LinkedField",
        "name": "updateIssueComment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "IssueComment",
            "kind": "LinkedField",
            "name": "issueComment",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "ae0c628cf339b6324362da464e2e3b13",
    "metadata": {},
    "name": "updateIssueCommentBodyMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "4be9b24f79220e9fcad78db58bb020ff";

export default node;
